import { Button, FilledButton, OutlinedButton } from '@sainsburys-tech/luna-button'
import { ILinkButton } from '../../../../../types/ComponentTypes/Components'
import { Container } from '@sainsburys-tech/luna-grid'
import { useNavigate } from "react-router"

function LinkButtonComponent({ value, link, buttonType }: ILinkButton) {
  const button = buttonType !== '' ? buttonType : 'filled'
  const navigateTo = useNavigate()
  
  const handleNavigation = () => {
    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.location.href = link
    } else {
      navigateTo(link)
    }
  }
  
  return (
    <div className="s-phone-button ln-u-push-bottom">
      <Container className="ln-u-push-ends">
        {
          {
            filled: (
              <a onClick={handleNavigation}>
                <FilledButton fullWidth>{value}</FilledButton>
              </a>
            ),
            outlined: (
              <a onClick={handleNavigation}>
                <OutlinedButton fullWidth>{value}</OutlinedButton>
              </a>
            ),
            outlined_dark: (
              <a onClick={handleNavigation}>
                <Button variant="outlined" color="dark" fullWidth>
                  {value}
                </Button>
              </a>
            )
          }[button]
        }
      </Container>
    </div>
  )
}

export default LinkButtonComponent
